var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.78,
    height: 23.799,
    viewBox: "0 0 23.78 23.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M23.746,4.121a1.064,1.064,0,0,1-.042.124.934.934,0,0,1-.053.154.91.91,0,0,1-.129.194,1,1,0,0,1-.057.087l-9.91,9.9c-.017.017-.04.023-.057.038a1.38,1.38,0,0,1-.343.194c-.022.007-.038.023-.061.029l-3.965.991a.98.98,0,0,1-.24.03.991.991,0,0,1-.962-1.231l.991-3.963c.006-.023.022-.039.03-.061a.975.975,0,0,1,.085-.179.952.952,0,0,1,.108-.162c.015-.018.021-.041.038-.058L19.09.308a.854.854,0,0,1,.1-.064.95.95,0,0,1,.167-.111.9.9,0,0,1,.189-.067A.8.8,0,0,1,19.65.028a3.927,3.927,0,0,1,3.222.965A4.043,4.043,0,0,1,23.746,4.121ZM21.424,2.346a1.738,1.738,0,0,0-1.2-.372l-9.451,9.445-.524,2.1,2.1-.524L21.8,3.546A1.856,1.856,0,0,0,21.424,2.346ZM12,3.812H2l-.049,18,18.049,0v-10a1,1,0,0,1,2,0v11c0,.547-.67.978-1.218.978H.96A.954.954,0,0,1,0,22.812v-20a1.007,1.007,0,0,1,1-1H12a1,1,0,0,1,0,2Z",
    transform: "translate(0 0.009)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditWhite);
export default __webpack_public_path__ + "static/media/edit-white.a70127fdca984d464e53c93bc7bfa8b7.svg";
export { ForwardRef as ReactComponent };